import "./src/styles/global.css";
import "./src/styles/strapi-theme.css";

export { wrapPageElement } from "./src/wrapPageElement";


/**
 * Called after React has finished hydrating the page on the client side.
 * This is the perfect place to signal to parent windows (e.g., iframe embedders)
 * that the app is ready for interaction.
 */
export const onInitialClientRender = () => {
  // Check if we're running inside an iframe
  console.debug('[Site Builder] Sending APP_READY signal to parent window');

  // Signal to parent window that React hydration is complete
  window.parent.postMessage({ type: 'APP_READY' }, '*');
};
